import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import Button from "@mui/material/Button";
import { getUsers } from "../../../redux/user/userSelectors";
import { fetchAllUsers, createUser, setUserPassword, showAlert } from "../../../redux";
import { connect } from "react-redux";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { Box } from "@mui/system";
import Modal from '@mui/material/Modal';
import TextField from "@mui/material/TextField";
import { requestState } from "../../../redux/type/type";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import LockResetIcon from '@mui/icons-material/LockReset';

const User = (props) => {
  const [openCreate, setOpenCreate] = useState(false);
  const [openPassword, setOpenPassword] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const handleCreateModalOpen = () => setOpenCreate(true);
  const handleCreateModalClose = () => setOpenCreate(false);
  
  const handlePasswordModalOpen = (userId) => {
    setSelectedUserId(userId);
    setOpenPassword(true);
  };
  const handlePasswordModalClose = () => {
    setSelectedUserId(null);
    setOpenPassword(false);
  };

  const { users, fetchAllUsers, createUser, setUserPassword } = props;

  useEffect(() => {
    fetchAllUsers();
  }, []);

  const createUserHandler = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    const userData = {
      name: data.get('name'),
      email: data.get('email'),
      password: data.get('password')
    };
    
    try {
      await createUser(userData).unwrap();
      handleCreateModalClose();
      props.showAlert("User created successfully!", "success");
      fetchAllUsers();
    } catch (rejectedValueOrSerializedError) {
      props.showAlert("User creation failed!", "error");
    }
  };

  const setPasswordHandler = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    const password = data.get('password');
    
    try {
      await setUserPassword({ userId: selectedUserId, password }).unwrap();
      handlePasswordModalClose();
      props.showAlert("Password updated successfully!", "success");
    } catch (rejectedValueOrSerializedError) {
      props.showAlert("Password update failed!", "error");
    }
  };

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    borderRadius: '5px',
    boxShadow: 24,
    p: 4,
  };

  if (users.status === requestState.loading) {
    return <div>Loading....</div>;
  } else {
    return (
      <>
        <Grid container spacing={3} alignItems="center" columns={12}>
          <Grid
            sx={{
              width: "100%",
              margin: 0,
              display: "flex"
            }}
            justifyContent="space-between"
          >
            <Typography variant="h6" gutterBottom>
              Users
            </Typography>
            <Button variant="contained" onClick={handleCreateModalOpen}>
              Add User
            </Button>
          </Grid>
          <Grid xs={12}>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="users table">
                <TableHead>
                  <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell align="right">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {users.users.map((user) => (
                    <TableRow key={user.id}>
                      <TableCell>{user.id}</TableCell>
                      <TableCell>{user.name}</TableCell>
                      <TableCell>{user.email}</TableCell>
                      <TableCell align="right">
                        <IconButton 
                          color="primary" 
                          onClick={() => handlePasswordModalOpen(user.id)}
                          title="Reset Password"
                        >
                          <LockResetIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>

        {/* Create User Modal */}
        <Modal
          open={openCreate}
          onClose={handleCreateModalClose}
          aria-labelledby="create-user-modal"
        >
          <Box sx={modalStyle} component="form" onSubmit={createUserHandler}>
            <Typography id="create-user-modal" variant="h6" component="h2" sx={{ marginBottom: '10px' }}>
              Create User
            </Typography>
            <TextField
              fullWidth
              label="Name"
              id="name"
              name="name"
              required
              sx={{ marginBottom: '10px' }}
            />
            <TextField
              fullWidth
              label="Email"
              id="email"
              name="email"
              type="email"
              required
              sx={{ marginBottom: '10px' }}
            />
            <TextField
              fullWidth
              label="Password"
              id="password"
              name="password"
              type="password"
              required
            />
            <Box display='flex' justifyContent='flex-end'>
              <Button variant="contained" size="small" type="submit" sx={{ marginTop: '10px' }}>
                Create
              </Button>
            </Box>
          </Box>
        </Modal>

        {/* Set Password Modal */}
        <Modal
          open={openPassword}
          onClose={handlePasswordModalClose}
          aria-labelledby="set-password-modal"
        >
          <Box sx={modalStyle} component="form" onSubmit={setPasswordHandler}>
            <Typography id="set-password-modal" variant="h6" component="h2" sx={{ marginBottom: '10px' }}>
              Set New Password
            </Typography>
            <TextField
              fullWidth
              label="New Password"
              id="password"
              name="password"
              type="password"
              required
            />
            <Box display='flex' justifyContent='flex-end'>
              <Button variant="contained" size="small" type="submit" sx={{ marginTop: '10px' }}>
                Update
              </Button>
            </Box>
          </Box>
        </Modal>
      </>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    users: getUsers(state),
    alert: state.alert
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchAllUsers: () => dispatch(fetchAllUsers()),
    createUser: (userData) => dispatch(createUser(userData)),
    setUserPassword: (data) => dispatch(setUserPassword(data)),
    showAlert: (message, type) => dispatch(showAlert(message, type)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(User);
